<template>
  <div>
    <el-row>
      <el-col>
        <el-col>
          <el-table :data="tableData" border stripe style="margin-top: 20px">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_BATCH" label="产品批次"></el-table-column>
            <el-table-column prop="PRICE" label="价格"></el-table-column>
            <!-- <el-table-column prop="BEFORE_TAX_PRICE" label="不含税价格" min-width="45"></el-table-column> -->
            <!-- <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column> -->
            <el-table-column prop="RETURN_COUNT" label="退库数量"></el-table-column>
            <el-table-column prop="RETURN_FEE" label="退库金额"></el-table-column>
            <!-- <el-table-column prop="COMMENT" label="退库原因"></el-table-column> -->
            <el-table-column prop="USER_NAME" label="退库人"></el-table-column>
            <el-table-column prop="OPERATE_TIME" label="操作时间"></el-table-column>
          </el-table>
        </el-col>
      </el-col>
      <el-col>
        <el-button @click="toPrintTable" style="float: right;margin-top: 10px">打印</el-button>
      </el-col>
      <el-col>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { print } from 'api/warehouseManager';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      titleData: { ...JSON.parse(sessionStorage.getItem('proPickingDocReturnDetailTitle')) },
      companyName: '',
      isDisplay: 'none',
    };
  },
  created() {
    this.queryData();
    console.log(this.titleData);
    this.companyName = sessionStorage.getItem('company');
    if (sessionStorage.getItem('tcId') == 4097) {
      this.isDisplay = 'flex';
    }
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '10056',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        RETURN_ORDER_ID: Number(this.$route.params.id),
      };
      http.post(params).then((res) => {
        this.tableData = res.map((item) => ({ ...item, PRODUCT_FEE: Number(item.PRODUCT_COUNT * item.PRODUCT_PRICE).toFixed(2) }));
        this.titleData = { ...this.titleData };
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main" >';
      html += `<div class="title">${this.companyName}生产领料退库单</div>`;
      html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">领料单ID：${this.titleData.ORDER_ID}</div><div class="code">领料人：${this.titleData.RECEIVER}</div><div>领料部门：${this.titleData.DEPARTMENT_NAME}</div></div>`;
      html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">领料日期：${this.titleData.SEND_DAY}</div></div>`;
      html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
      html += '<tr style="text-align: center"><td style="width: 40px">序号</td><td>产品编码</td> <td>产品</td> <td>单位</td> <td  style="width: 40px">单价</td> <td style="width: 70px">退库数量</td> <td  style="width: 70px">退库金额</td> <td>退库原因</td> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center;font-size: 14px">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_CODE}</td> <td>${item.PRODUCT_NAME}</td><td>${item.TYPE_UNIT}</td><td>${item.PRICE}</td>
                        <td>${item.RETURN_COUNT}</td> <td>${item.RETURN_FEE} </td> <td></td>`;// ${item.COMMENT}
        html += '</tr>';
      });
      html += '</div>';
      html += `<div class="divTop" style="font-size:12px; right:1%; flex-direction: column; position:absolute; page-break-after: always; position: fixed;  top: 250px; display:${this.isDisplay}">`;
      html += '<span style="font-size:15px">白</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">财</span>';
      html += '<span style="font-size:15px">务</span>';
      html += '<div style="height:5px;"> </div>';
      html += '<span style="font-size:15px">红</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">存</span>';
      html += '<span style="font-size:15px">根</span>';
      html += '<div style="height:5px;"></div>';
      html += '<span style="font-size:15px">黄</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">领</span>';
      html += '<span style="font-size:15px">料</span>';
      // html += '<span style="font-size:15px">/</span>';
      // html += '<span style="font-size:15px">仓</span>';
      // html += '<span style="font-size:15px">库</span>';
      // html += '<span style="font-size:15px">/</span>';
      // html += '<span style="font-size:15px">客</span>';
      // html += '<span style="font-size:15px">户</span>';
      html += '</div>';
      html += '</table>';
      html += `<div class="head" style="margin-top: 20px; flex-direction: Row-Reverse; font-size: 16px;"><div class="code">退库总金额：${this.tableData.reduce((total, item) => total += Number(item.RETURN_FEE), 0).toFixed(2)}</div><div class="code">主管：</div><div class="code">退库人：</div></div>`;
      // html += '<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>退库人：</div><div style="margin-left: 200px;font-size: 20px;">主管：</div></div>';
      html += '</div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/proPickingDocReturnDetail.vue